import React from 'react';
import { Link } from 'react-router-dom';
import './VPS.css';

const VPS = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const vpsTypes = [
    {
      icon: '🐧',
      title: 'سرور مجازی لینوکس',
      desc: 'سرور مجازی با سیستم‌عامل لینوکس و دسترسی روت کامل. مناسب برای توسعه‌دهندگان، برنامه‌نویسان و پروژه‌های مبتنی بر PHP، Python، Node.js و Ruby. با کنترل پنل‌های cPanel و DirectAdmin قابل مدیریت است.',
      features: ['Root Access', 'NVMe Storage', 'پشتیبانی ۲۴/۷', 'قیمت مناسب'],
      link: '/vps/linux',
      color: '#8B5CF6',
    },
    {
      icon: '🪟',
      title: 'سرور مجازی ویندوز',
      desc: 'سرور مجازی با سیستم‌عامل ویندوز و لایسنس رسمی. مناسب برای اپلیکیشن‌های دات‌نت، برنامه‌های سازمانی و پروژه‌هایی که نیاز به محیط ویندوز دارند. با کنترل پنل Plesk قابل مدیریت است.',
      features: ['لایسنس ویندوز', 'RDP Access', 'MSSQL', 'پشتیبانی ۲۴/۷'],
      link: '/vps/windows',
      color: '#3B82F6',
    },
    {
      icon: '🛡️',
      title: 'سرور مجازی مدیریت شده',
      desc: 'سرور مجازی با مدیریت کامل توسط تیم حرفه‌ای افراسل. شامل نصب و راه‌اندازی، به‌روزرسانی امنیتی، پشتیبانی ۲۴ ساعته و عیب‌یابی. مناسب برای کسانی که دانش فنی کافی ندارند یا وقت کافی برای مدیریت سرور ندارند.',
      features: ['مدیریت کامل', 'امنیت پیشرفته', 'پشتیبانی ۲۴/۷', 'آپدیت خودکار'],
      link: '/vps/managed',
      color: '#06B6D4',
    },
    {
      icon: '🇳🇱',
      title: 'سرور مجازی هلند',
      desc: 'سرور مجازی در دیتاسنتر معتبر هلند با پینگ پایین برای اروپا و خاورمیانه. مناسب برای وب‌سایت‌های بین‌المللی، بازی‌های آنلاین و پروژه‌های نیازمند پهنای باند بالا.',
      features: ['لوکیشن هلند', 'پینگ پایین', 'پهنای باند بالا', 'پشتیبانی ۲۴/۷'],
      link: '/vps/netherlands',
      color: '#F97316',
    },
    {
      icon: '🇩🇪',
      title: 'سرور مجازی آلمان',
      desc: 'سرور مجازی در دیتاسنتر معتبر آلمان با بهترین کیفیت و پایدار‌ی. مناسب برای وب‌سایت‌های اروپایی، فروشگاه‌های آنلاین و پروژه‌های سازمانی با نیاز به پایدار‌ی بالا.',
      features: ['لوکیشن آلمان', 'پایدار‌ی بالا', 'امنیت عالی', 'پشتیبانی ۲۴/۷'],
      link: '/vps/germany',
      color: '#F59E0B',
    },
    {
      icon: '📡',
      title: 'سرور مجازی میکروتیک',
      desc: 'سرور مجازی با سیستم‌عامل RouterOS میکروتیک. مناسب برای مدیریت شبکه، VPN، فایروال و NAT. انتخابی عالی برای شرکت‌های شبکه و ارائه‌دهندگان خدمات اینترنت.',
      features: ['RouterOS', 'مدیریت شبکه', 'VPN', 'پشتیبانی ۲۴/۷'],
      link: '/vps/mikrotik',
      color: '#EC4899',
    },
    {
      icon: '🇹🇷',
      title: 'سرور مجازی ترکیه',
      desc: 'سرور مجازی در دیتاسنتر ترکیه با قیمت مناسب و پینگ عالی برای ایران و خاورمیانه. مناسب برای وب‌سایت‌های فارسی، فروشگاه‌های آنلاین و پروژه‌های منطقه‌ای.',
      features: ['لوکیشن ترکیه', 'پینگ عالی', 'قیمت مناسب', 'پشتیبانی ۲۴/۷'],
      link: '/vps/turkey',
      color: '#EF4444',
    },
    {
      icon: '🇺🇸',
      title: 'سرور مجازی آمریکا',
      desc: 'سرور مجازی در دیتاسنترهای معتبر آمریکا با پهنای باند بالا و دسترسی عالی به شبکه‌های جهانی. مناسب برای وب‌سایت‌های بین‌المللی و پروژه‌های نیازمند حضور در آمریکا.',
      features: ['لوکیشن آمریکا', 'پهنای باند بالا', 'دسترسی جهانی', 'پشتیبانی ۲۴/۷'],
      link: '/vps/usa',
      color: '#3B82F6',
    },
    {
      icon: '🇬🇧',
      title: 'سرور مجازی انگلستان',
      desc: 'سرور مجازی در دیتاسنتر معتبر انگلستان با پینگ عالی برای اروپا و ارتباط خوب با خاورمیانه. مناسب برای وب‌سایت‌های بین‌المللی و پروژه‌های سازمانی.',
      features: ['لوکیشن انگلستان', 'پینگ عالی', 'پایدار‌ی بالا', 'پشتیبانی ۲۴/۷'],
      link: '/vps/uk',
      color: '#EF4444',
    },
    {
      icon: '🇫🇷',
      title: 'سرور مجازی فرانسه',
      desc: 'سرور مجازی در دیتاسنتر فرانسه با بهترین کیفیت و پایدار‌ی. مناسب برای وب‌سایت‌های اروپایی و پروژه‌های نیازمند دیتاسنتر اروپایی با قوانین GDPR.',
      features: ['لوکیشن فرانسه', 'پایدار‌ی بالا', 'GDPR Ready', 'پشتیبانی ۲۴/۷'],
      link: '/vps/france',
      color: '#1E3A5F',
    },
    {
      icon: '🇨🇦',
      title: 'سرور مجازی کانادا',
      desc: 'سرور مجازی در دیتاسنتر کانادا با پهنای باند بالا و دسترسی عالی به آمریکای شمالی. مناسب برای وب‌سایت‌های بین‌المللی و پروژه‌های نیازمند حضور در آمریکای شمالی.',
      features: ['لوکیشن کانادا', 'پهنای باند بالا', 'دسترسی عالی', 'پشتیبانی ۲۴/۷'],
      link: '/vps/canada',
      color: '#EF4444',
    },
  ];

  const faqs = [
    {
      q: 'سرور مجازی (VPS) چیست و چه تفاوتی با هاست اشتراکی دارد؟',
      a: 'VPS یا سرور مجازی، یک سرور اختصاصی مجازی است که روی یک سرور فیزیکی قدرتمند ایجاد می‌شود. برخلاف هاست اشتراکی که منابع بین کاربران تقسیم می‌شود، در VPS شما منابع اختصاصی دارید و عملکرد وب‌سایت شما تحت تأثیر سایر کاربران قرار نمی‌گیرد. VPS به شما دسترسی روت، کنترل کامل روی سرور و امکان نصب هر نرم‌افزاری را می‌دهد. این سرویس برای وب‌سایت‌های با ترافیک بالا، فروشگاه‌های آنلاین و اپلیکیشن‌های وب مناسب است.',
    },
    {
      q: 'آیا برای مدیریت VPS نیاز به دانش فنی دارم؟',
      a: 'بله، مدیریت VPS نیاز به دانش فنی در زمینه سیستم‌عامل لینوکس یا ویندوز، خط فرمان و مدیریت سرور دارد. با این حال، اگر دانش فنی کافی ندارید، می‌توانید از سرویس VPS مدیریت شده افراسل استفاده کنید. در این سرویس، تیم حرفه‌ای ما تمام کارهای مدیریتی از جمله نصب، راه‌اندازی، به‌روزرسانی و امنیت را برای شما انجام می‌دهد و شما فقط روی وب‌سایت خود متمرکز می‌شوید.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>خرید سرور مجازی VPS | سرور مجازی لینوکس و ویندوز با بهترین قیمت | افراسل</h1>
        <p>خرید سرور مجازی با بهترین قیمت و پشتیبانی ۲۴ ساعته. انواع سرور مجازی لینوکس، ویندوز، مدیریت شده و لوکیشن‌های مختلف شامل ایران، هلند، آلمان، ترکیه، آمریکا، انگلستان، فرانسه و کانادا. پشتیبانی ۲۴/۷، آپتایم ۹۹.۹٪ و قیمت‌های رقابتی.</p>
        <meta name="description" content="خرید VPS با بهترین قیمت از افراسل. سرور مجازی لینوکس، ویندوز، مدیریت شده و لوکیشن‌های مختلف. پشتیبانی ۲۴/۷، آپتایم ۹۹.۹٪ و قیمت‌های رقابتی." />
      </div>

      <section className="vps-main-hero">
        <div className="vps-main-hero-bg"></div>
        <div className="wrap">
          <div className="vps-main-hero-content">
            <div className="vps-main-badge">
              <span className="pulse-dot"></span>
              🚀 سرور مجازی حرفه‌ای
            </div>
            <h1 className="vps-main-hero-title">
              سرور مجازی <em>VPS</em> مناسب کسب‌وکار شما
            </h1>
            <p className="vps-main-hero-desc">
              سرور مجازی با بهترین قیمت، پایدار‌ی بالا و پشتیبانی ۲۴ ساعته.
              انتخاب از بین لوکیشن‌های مختلف و سیستم‌عامل‌های متنوع. 
              از VPS لینوکس و ویندوز تا VPS مدیریت شده و لوکیشن‌های ایران، هلند، آلمان، ترکیه و آمریکا.
              سرور مجازی یا VPS یک راه‌حل میانی بین هاست اشتراکی و سرور اختصاصی است که با هزینه کمتر، عملکردی نزدیک به سرور اختصاصی ارائه می‌دهد. با انتخاب VPS، شما کنترل کامل روی سرور خود دارید و می‌توانید هر نرم‌افزاری را نصب و اجرا کنید.
            </p>
            <div className="vps-main-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۱۱+</span>
                <span className="stat-label">نوع VPS</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۹۹.۹٪</span>
                <span className="stat-label">آپتایم تضمینی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-types">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">انواع VPS</span>
            <h2 className="sec-h">انتخاب <em>VPS</em> مناسب نیاز شما</h2>
            <p className="sec-p">از VPS لینوکس و ویندوز تا VPS مدیریت شده و لوکیشن‌های مختلف، همه را با بهترین کیفیت در افراسل پیدا کنید.</p>
          </div>
          <div className="vps-types-grid">
            {vpsTypes.map((type, i) => (
              <Link to={type.link} key={i} className="vps-type-card">
                <span className="vps-type-icon">{type.icon}</span>
                <h3 className="vps-type-title">{type.title}</h3>
                <p className="vps-type-desc">{type.desc}</p>
                <ul className="vps-type-features">
                  {type.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <span className="vps-type-link" style={{ color: type.color }}>
                  مشاهده جزئیات ←
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-main-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
            <p className="sec-p">پاسخ سوالات رایج درباره خرید و مدیریت سرور مجازی VPS.</p>
          </div>
          <div className="vps-main-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-main-faq-item">
                <div className="vps-main-faq-q">{faq.q}</div>
                <div className="vps-main-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-main-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>مناسب</em> خود را انتخاب کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS از افراسل، از سرعت بالا، پایدار‌ی عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
              انتخاب از بین لوکیشن‌های مختلف و سیستم‌عامل‌های متنوع.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
              <button className="btn-lg ghost" onClick={() => {
                const el = document.querySelector('.vps-types-grid');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>
                مشاهده انواع VPS
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPS;
